export const GET_LIST_TRAGOP = "GET_LIST_TRAGOP";
export const GET_LIST_TRAGOP_SUCCESS = "GET_LIST_TRAGOP_SUCCESS";
export const GET_LIST_TRAGOP_FAILURE = "GET_LIST_TRAGOP_FAILURE";
